import HeaderProgress from './HeaderProgress';

export default HeaderProgress;
